import apps from "@services/applications";

export default [
  {
    path: "/app/automation-server",
    name: "automation-server",
    meta: {
      module: "automation-server",
      application: apps.Modules.AutomationServer.Id,
      title: "Automation Server",
      licenseName: "AutomationServer"
    },
    component: () => import("@AutomationServer/views/AutomationServer.vue")
  },
  {
    path: "/app/automation/:id",
    name: "automation-details",
    meta: {
      module: "automation-server",
      application: apps.Modules.AutomationServer.Id,
      authenticatedRoute: true
    },
    component: () => import("@AutomationServer/views/Automation.vue")
  }
];
